import enIcon from "../../assets/icons/en.svg";

const ENIcon = () => {
  return <img src={enIcon} width={21} height={14} style={{ borderRadius: 2 }} />;
};

export default ENIcon;
